import { render, staticRenderFns } from "./addQuestion.vue?vue&type=template&id=774dd640&scoped=true"
import script from "./addQuestion.vue?vue&type=script&lang=js"
export * from "./addQuestion.vue?vue&type=script&lang=js"
import style0 from "./addQuestion.vue?vue&type=style&index=0&id=774dd640&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774dd640",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('774dd640')) {
      api.createRecord('774dd640', component.options)
    } else {
      api.reload('774dd640', component.options)
    }
    module.hot.accept("./addQuestion.vue?vue&type=template&id=774dd640&scoped=true", function () {
      api.rerender('774dd640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/question-manage/addQuestion.vue"
export default component.exports